import React from 'react'
import ServerInfoRound from './ServerInfoRound'
import ServerInfoGameMode from './ServerInfoGameMode'
import LanguageSwitcher from '../../LanguageSwitcher'
import ServerBarConfig from './ServerBarConfig'
import ServerInfoDamageMultiplier from './ServerInfoDamageMultiplier'
import { useDeviceInfo } from '@/hooks/useIsMobile'

const ServerInfoBar = () => {
    const { isMobile } = useDeviceInfo();
    return (
        <div className={`absolute right-3 text-[#FFFBD4] text-shadow shadow-yellow-800/90 flex gap-6 items-center z-[100] pointer-events-none select-none ${isMobile ? 'h-12' : 'top-[9px]'}`}>
            {!isMobile && (
                <>
                    <div className="absolute right-[-20px] z-[1] h-[42px] w-[calc(100%+40px)] backdrop-blur-sm" style={{ maskImage: 'linear-gradient(to left, white, transparent)' }}></div>
                    <div className="absolute right-[-20px] z-[1] h-[42px] w-[calc(100%+40px)] blur-sm bg-gradient-to-l from-black/50 via-black/50 via-80% to-transparent"></div>
                </>
            )}
            <div className="flex gap-3 xl:gap-6 items-center z-10">
                {!isMobile && <ServerInfoGameMode />}
                <ServerInfoDamageMultiplier />
                <ServerInfoRound />
                <LanguageSwitcher />
                {!isMobile && <ServerBarConfig />}
            </div>
        </div>
    )
}

export default ServerInfoBar